import { render, staticRenderFns } from "./PurInvoiceCard.vue?vue&type=template&id=472586f5&"
import script from "./PurInvoiceCard.vue?vue&type=script&lang=js&"
export * from "./PurInvoiceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports